import styled from 'styled-components';
import { pxToRems } from '@awaze/design-system.utils.react';
export const MINIMUM_CELL_WIDTH = 44;
export const CalendarContainer = styled.div `
  display: flex;
  flex-wrap: wrap;
  min-width: ${pxToRems(MINIMUM_CELL_WIDTH * 7)};
`;
export const StyledDayBox = styled.div `
  min-width: ${pxToRems(MINIMUM_CELL_WIDTH)};
  width: 14.285%;
  padding-bottom: ${(p) => (p.largeAmounts ? 23 : 14.285)}%;
  height: 0;
  position: relative;
  margin: 0.33% 0;

  @media (min-width: 475px) and (max-width: 1024px) {
    padding-bottom: 14.285%;
  }
`;
export const StyledDayLabelBox = styled(StyledDayBox) `
  font-size: ${pxToRems(12)};
  padding-bottom: ${pxToRems(8)};
  line-height: ${pxToRems(16)};
  text-align: center;
  border-bottom: 1px solid ${({ theme }) => theme.ColorGrey100};
  height: auto;
`;
export const StyledDayContent = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const StyledMonth = styled.div `
  flex-basis: ${({ monthsToShow, horizontal }) => horizontal && `${100 / monthsToShow}%`};
`;
export const StyledTextWrapper = styled.div `
  text-align: center;
  height: auto !important;
`;
//# sourceMappingURL=calendar-month.styles.js.map